import { useTranslation } from 'react-i18next'

import { IconAlert } from '@shared/icons'
import { rules } from '@shared/innmaxLib/utils/form'
import { Input } from '@shared/innmaxUI/Form'
import Button from '@shared/innmaxUI/Form/Button'
import Form from '@shared/innmaxUI/Form/Form'
import Modal, { ModalProps } from '@shared/innmaxUI/Modal'

type IProofingConfirmModalProps = {
  proofingText: string
  content: string | React.ReactNode
  onCancel: () => void
  onOk: () => void
  okText?: string
  loading?: boolean
} & Omit<ModalProps, 'onCancel' | 'onOk'>

export default function ProofingConfirmModal(
  props: IProofingConfirmModalProps
) {
  const { t } = useTranslation()

  const { proofingText, content, onCancel, onOk, visible , loading = false} = props

  const [form] = Form.useForm()

  const handleOnFinish = () => {
    form.validateFields().then(() => {
      onOk && onOk()
    })
  }

  const handleOnCancel = () => {
    onCancel && onCancel()
  }

  return (
    <Modal
      title=""
      destroyOnClose
      onCancel={handleOnCancel}
      width="560px"
      open={visible}
      loadingData={loading}
      footer={[
        <Button
          key="btn-ok"
          type="danger"
          ghost
          className="mr-8"
          size="small"
          style={{ minWidth: 96 }}
          onClick={form.submit}>
          {props?.okText || t('common:go to edit')}
        </Button>,
        <Button
          key="btn-cancel"
          type="primary"
          size="small"
          style={{ minWidth: 96 }}
          onClick={onCancel}>
          {t('common:cancel')}
        </Button>,
      ]}>
      <Form
        form={form}
        className="text-normal font-medium ml-29 mr-29 mb-30"
        css={{ fontSize: 15, fontWeight: 500 }}
        onFinish={handleOnFinish}>
        <div className="text-center">
          <IconAlert className="mx-auto mb-16" />
          {content}
          <input type="submit" style={{ display: 'none' }} />
          <Form.Item
            label=""
            rules={[
              rules.required,
              () => ({
                validator(_, value) {
                  if (!value || proofingText === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(
                    new Error(t('session:input error try again'))
                  )
                },
              }),
            ]}
            name="baseLayerName">
            <Input
              style={{ width: 240, marginTop: 16 }}
              placeholder={`${t('common:please input')}${proofingText}`}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}
